import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Aux from './../../../../hoc/_Aux';

import historiqueSvg from './../../../../assets/images/icons/historique.svg';

export class HistoryButton extends Component {


    onClickHandler = () => {
        const { dispatch } = this.props;
        dispatch(push("/account/historique"));
    }

    render(){
        return(
            <Aux>
                <span className={this.props.className} onClick={this.onClickHandler}>
                    <img src={historiqueSvg} alt="Historique" />
                </span>
            </Aux>
        );
    }
}

export default connect(null)(HistoryButton);





// WEBPACK FOOTER //
// ./src/components/UI/Common/HistoryButton/HistoryButton.js